import { RenderingProps } from '@/shared/shared.types';
import { BiographyDirectoryFields } from '@/shared/BiographyItem.types';

export type C55BiographyDirectoryProps = RenderingProps<BiographyDirectoryFields>;
